export default __webpack_public_path__ + "static/media/icon1.a5869323.png";